// Inventor's "Struktura zestawienia BOM", mirrored one-to-one (BomStructure.cs). Stored and
// shown; only Purchased acts so far — the API skips a bought part at every stage by default,
// and a line skipped everywhere does not gate its parent (0115). The planner treats it like
// every other item, and PODSUMOWANIE counts it as the material without what is under it (0120)
export type BomStructure = 'Normal' | 'Purchased' | 'Phantom' | 'Reference' | 'Inseparable';

export const BOM_STRUCTURES: BomStructure[] = ['Normal', 'Purchased', 'Phantom', 'Reference', 'Inseparable'];

export const STRUCTURE_LABELS: Record<BomStructure, string> = {
  Normal: 'Normalne',
  Purchased: 'Kupione',
  Phantom: 'Fantom',
  Reference: 'Odniesienie',
  Inseparable: 'Nierozłączne'
};
